/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eb7b4c750a7f04d30242ae2bfbe6bd3f>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Glasses".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Changing tone of written content to Educational with Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const GlassesIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 10.5a2.75 2.75 0 1 0 5.391-.768M.75 10.5a2.75 2.75 0 0 1 5.391-.768M.75 10.5l.863-6.47a1.88 1.88 0 0 1 1.082-1.46L4.5 1.75m10.75 8.75a2.75 2.75 0 1 1-5.391-.768m5.391.768a2.75 2.75 0 0 0-5.391-.768m5.391.768-.863-6.47a1.88 1.88 0 0 0-1.082-1.46L11.5 1.75M6.141 9.732A2.25 2.25 0 0 1 8 8.75c.772 0 1.454.389 1.859.982"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
GlassesIcon.displayName = 'GlassesIcon';
var _default = exports.default = GlassesIcon;